import { UserService } from '../services/user.services';

export default {

  computed: {
    currentUser() {
      return UserService.getCurrentUser();
    },

    isSuperAdmin() {
      return UserService.isSuperAdmin(this.currentUser);
    },

    isOrganizationAdmin() {
      return UserService.isOrganizationAdmin(this.currentUser);
    }, 

    isScanningAdmin() {
      return UserService.isScanningAdmin(this.currentUser);
    },

    isBindezAdmin() {
      return UserService.isBindezAdmin(this.currentUser);
    },

    currentUserRole() {
      return this.currentUser.roles[0].code;
    }
  }

}